// -------------------------------------------
//   ANIMATIONS > FADE
// -------------------------------------------
import { replacePXinStringWithEM } from 'utils/styles/style_helpers';



// (((((((((( ~~~~~~~~~~ FADE IN ~~~~~~~~~~ )))))))))) //
const fadeIn = {
	'@global': {
		// ***** FADE IN ***** //
		'@keyframes fadeIn': {
			from: {
				opacity: '0'
			},
			to: {
				opacity: '1'
			}
		},

		// ***** FADE IN : DOWN ***** //
		'@keyframes fadeInDown': {
			from: {
				opacity: '0',
				transform: 'translate3d(0, -100%, 0)'
			},
			to: {
				opacity: '1',
				transform: 'none'
			}
		},
		// ***** FADE IN : DOWN : BIG ***** //
		'@keyframes fadeInDownBig': {
			from: {
				opacity: '0',
				transform: replacePXinStringWithEM('translate3d(0, -2000px, 0)')
			},
			to: {
				opacity: '1',
				transform: 'none'
			}
		},

		// ***** FADE IN : LEFT ***** //
		'@keyframes fadeInLeft': {
			from: {
				opacity: '0',
				transform: 'translate3d(-100%, 0, 0)'
			},
			to: {
				opacity: '1',
				transform: 'none'
			}
		},
		// ***** FADE IN : LEFT : BIG ***** //
		'@keyframes fadeInLeftBig': {
			from: {
				opacity: '0',
				transform: replacePXinStringWithEM('translate3d(-2000px, 0, 0)')
			},
			to: {
				opacity: '1',
				transform: 'none'
			}
		},

		// ***** FADE IN : RIGHT ***** //
		'@keyframes fadeInRight': {
			from: {
				opacity: '0',
				transform: 'translate3d(100%, 0, 0)'
			},
			to: {
				opacity: '1',
				transform: 'none'
			}
		},
		// ***** FADE IN : RIGHT : BIG ***** //
		'@keyframes fadeInRightBig': {
			from: {
				opacity: '0',
				transform: replacePXinStringWithEM('translate3d(2000px, 0, 0)')
			},
			to: {
				opacity: '1',
				transform: 'none'
			}
		},

		// ***** FADE IN : UP ***** //
		'@keyframes fadeInUp': {
			from: {
				opacity: '0',
				transform: 'translate3d(0, 100%, 0)'
			},
			to: {
				opacity: '1',
				transform: 'none'
			}
		},
		// ***** FADE IN : UP : BIG ***** //
		'@keyframes fadeInUpBig': {
			from: {
				opacity: '0',
				transform: replacePXinStringWithEM('translate3d(0, 2000px, 0)')
			},
			to: {
				opacity: '1',
				transform: 'none'
			}
		}
	}
};



// (((((((((( ~~~~~~~~~~ FADE OUT ~~~~~~~~~~ )))))))))) //
const fadeOut = {
	'@global': {
		// ***** FADE OUT ***** //
		'@keyframes fadeOut': {
			from: {
				opacity: '1'
			},
			to: {
				opacity: '0'
			}
		},

		// ***** FADE OUT : DOWN ***** //
		'@keyframes fadeOutDown': {
			from: {
				opacity: '1'
			},
			to: {
				opacity: '0',
				transform: 'translate3d(0, 100%, 0)'
			}
		},
		// ***** FADE OUT : DOWN : BIG ***** //
		'@keyframes fadeOutDownBig': {
			from: {
				opacity: '1'
			},
			to: {
				opacity: '0',
				transform: replacePXinStringWithEM('translate3d(0, 2000px, 0)')
			}
		},

		// ***** FADE OUT : LEFT ***** //
		'@keyframes fadeOutLeft': {
			from: {
				opacity: '1'
			},
			to: {
				opacity: '0',
				transform: 'translate3d(-100%, 0, 0)'
			}
		},
		// ***** FADE OUT : LEFT : BIG ***** //
		'@keyframes fadeOutLeftBig': {
			from: {
				opacity: '1'
			},
			to: {
				opacity: '0',
				transform: replacePXinStringWithEM('translate3d(-2000px, 0, 0)')
			}
		},

		// ***** FADE OUT : RIGHT ***** //
		'@keyframes fadeOutRight': {
			from: {
				opacity: '1'
			},
			to: {
				opacity: '0',
				transform: 'translate3d(100%, 0, 0)'
			}
		},
		// ***** FADE OUT : RIGHT : BIG ***** //
		'@keyframes fadeOutRightBig': {
			from: {
				opacity: '1'
			},
			to: {
				opacity: '0',
				transform: replacePXinStringWithEM('translate3d(2000px, 0, 0)')
			}
		},

		// ***** FADE OUT : UP ***** //
		'@keyframes fadeOutUp': {
			from: {
				opacity: '1'
			},
			to: {
				opacity: '0',
				transform: 'translate3d(0, -100%, 0)'
			}
		},
		// ***** FADE OUT : UP : BIG ***** //
		'@keyframes fadeOutUpBig': {
			from: {
				opacity: '1'
			},
			to: {
				opacity: '0',
				transform: replacePXinStringWithEM('translate3d(0, -2000px, 0)')
			}
		}
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { fadeIn, fadeOut };